import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchHomepage, fetchPage } from "@/lib/cmsApi";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import SectionRenderer from "@/components/site/SectionRenderer";
import NotFound from "@/pages/NotFound";

export default function DynamicPage({ homepage }) {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true); setNotFound(false);
    const loader = homepage ? fetchHomepage() : fetchPage(slug);
    loader.then((d) => {
      setPage(d);
      if (d?.meta_title) document.title = d.meta_title;
    }).catch((err) => {
      if (err?.response?.status === 404) setNotFound(true);
      else console.error("Page load failed", err);
    }).finally(() => setLoading(false));
  }, [slug, homepage]);

  if (loading) return <div className="min-h-screen bg-white" />;
  if (notFound || !page) return <NotFound />;

  return (
    <div className="min-h-screen bg-white text-[#0A0A0A] antialiased">
      <Navigation />
      <main>
        {(page.sections || []).map((s, i) => (
          <SectionRenderer key={s.id || i} section={s} />
        ))}
      </main>
      <Footer />
    </div>
  );
}
